
export const serverAddress = 'https://bytecraft.ir/expert/api/';

export const Apis = {
    is_auth_valid: serverAddress + 'users/authcheck',
    login: serverAddress + 'users/login',
    is_username_valid: serverAddress + 'users/usernamecheck?',
    logout: serverAddress + 'users/logout',
    register: serverAddress + 'users/create',
    new_exp: serverAddress + 'exps/create',
    get_skills: serverAddress + 'skills',
    skills_add: serverAddress + 'skills/add', // add new skill to skills table
    my_exps: serverAddress + 'exps/myexps',
    show_exp: serverAddress + 'exps/show',
    get_user_info: serverAddress + 'users/show/',
    update_user_info: serverAddress + 'users/update',
    get_user_related_exps: serverAddress + 'exps/showuserrelated',
    add_exp_comment: serverAddress + 'exps/responses/add',
    
    my_responses: serverAddress + 'users/responses',    // GET Values: user_id
    add_exp_comment: serverAddress + 'exps/responses/add',  // POST Values: exp_id, content
    changeLikeState: serverAddress + 'responses/like', // POST

    get_top_users: serverAddress + 'gettopusers',  // GET,

    get_notifications: serverAddress + 'notifications', // GET
    set_notification_read: serverAddress + 'notifications/read', // GET
}

